"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datesEqual = exports.isLabelHidden = exports.getTimeTopPosition = exports.dateFormat = exports.formatEvents = exports.localizeFormat = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var localizeFormat = function localizeFormat(localizer, date, format) {
  if (localizer.format(date) === undefined) {
    return date.toLocaleString('default', format);
  }

  return localizer.format(date, format);
};

exports.localizeFormat = localizeFormat;

var formatEvents = function formatEvents(data) {
  return data.map(function (event) {
    return _objectSpread(_objectSpread({}, event), {}, {
      end: new Date(event.endDate),
      start: new Date(event.startDate)
    });
  });
};

exports.formatEvents = formatEvents;

var dateFormat = function dateFormat(dayFormat, firstDayFormat) {
  return function (date, culture, localizer) {
    var isToday = new Date().toDateString() === date.toDateString();
    if (date.getDate() === 1 && isToday) return localizeFormat(localizer, date, dayFormat);
    return localizeFormat(localizer, date, date.getDate() === 1 ? firstDayFormat : dayFormat);
  };
};

exports.dateFormat = dateFormat;

var getTimeTopPosition = function getTimeTopPosition(date) {
  var seconds = (date.getHours() * 60 + date.getMinutes()) * 60;
  return "".concat(seconds / 86340 * 100, "%");
};

exports.getTimeTopPosition = getTimeTopPosition;

var isLabelHidden = function isLabelHidden(now, date) {
  return now.getHours() === date.getHours() || now.getHours() + 1 === date.getHours();
};

exports.isLabelHidden = isLabelHidden;

var datesEqual = function datesEqual(date, dateCompare) {
  return date.getFullYear() === dateCompare.getFullYear() && date.getMonth() === dateCompare.getMonth() && date.getDate() === dateCompare.getDate();
};

exports.datesEqual = datesEqual;